export const SecondSection = () => {
    const certificationInfo = [
        {
            title: "신뢰할 수 있는 공인 자격증",
            contents: [
                "현진 교수진이 직접 출제한 문제",
                "협회 인증으로 공신력 확보",
            ],
        },
        {
            title: "AI 번역 시대, 새로운 스펙",
            contents: [
                "프롬프트 언어, 웹툰 번역, 유튜브 번역 등 특화된 자격증",
                "다양한 분야에서 활용 가능한 실무 역량",
            ],
        },
        {
            title: "공부할 수록 실력이 쌓이는 과정",
            contents: [
                "전문 3급 → 전문 2급 → 전문 1급으로 단계별 성장",
                "실전 적용을 통해 자연스러운 실력 향상",
            ],
        },
    ];
    
    return (
        <section className={`py-20 px-16 bg-white text-center w-full flex-col`}>
            <div className={`w-full`}>
                <h5 className={`text-sm font-bold text-blue-600`}>Prove Your AI Translation Skills</h5>
                <h1 className={`text-3xl mb-8`}>AI 번역의 실력, 공인 자격으로 증명하세요.</h1>
                <h3 className={`text-xl`}>공인된 인증, 차별화된 자격, 성장하는 실력. 미래 번역 전문가의 새로운 기준!</h3>
            </div>
            <div className="flex gap-8 mt-20">
                {certificationInfo.map((item, itemIdx) => (
                    <div key={itemIdx} className="w-full text-left">
                        <div><img src={`/images/home/section2/${itemIdx+1}.png`} alt=""/></div>
                        <h1 className="text-2xl font-bold mb-1 text-blue-800">{item.title}</h1>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            {item.contents.map((content, contentIdx) => (
                                <li key={contentIdx} className={`ml-2`}>{content}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        
        </section>
    )
}